module.exports = __webpack_public_path__ + "static/img/lifestyle_19.1e07a9c4.jpg";